import React from 'react';
import './Header.css';
import { FiMenu, FiHome, FiCheckSquare, FiDollarSign, FiFileText, FiFile, FiLayers, FiPhone, FiLogOut, FiSettings, FiMoreHorizontal, FiCalendar } from 'react-icons/fi';
import { useAuth } from '../hooks/useAuth';

function Header({ currentPage, onPageChange }) {
  const [menuOpen, setMenuOpen] = React.useState(false);
  const { user, logout } = useAuth();

  const pages = [
    { id: 'dashboard', label: 'Tableau de bord', icon: FiHome },
    { id: 'tasks', label: 'Tâches', icon: FiCheckSquare },
    { id: 'budget', label: 'Budget', icon: FiDollarSign },
    { id: 'phases', label: 'Phases', icon: FiLayers },
    { id: 'invoices', label: 'Factures', icon: FiFileText },
    { id: 'documents', label: 'Documents', icon: FiFile },
    { id: 'appointments', label: 'Agenda', icon: FiCalendar },
    { id: 'contacts', label: 'Contacts', icon: FiPhone },
    { id: 'admin', label: 'Admin', icon: FiSettings }
  ];

  // Determine primary vs overflow pages to avoid too many visible icons
  const VISIBLE_COUNT = 5; // show first 5 items, rest go into "More"
  const visiblePages = pages.slice(0, VISIBLE_COUNT);
  const overflowPages = pages.slice(VISIBLE_COUNT);
  const [moreOpen, setMoreOpen] = React.useState(false);

  // Ajouter le lien Admin si l'utilisateur est admin
  const isAdmin = !!user?.is_admin; // se base sur la propriété is_admin fournie par le backend
  if (isAdmin) {
    pages.push({ id: 'admin', label: 'Admin', icon: FiSettings });
  }

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <h1>🏗️ Construction Tracker</h1>
        </div>
        
        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          <FiMenu size={24} />
        </button>

        <nav className={`nav ${menuOpen ? 'open' : ''}`}>
          {visiblePages.map(page => {
            const Icon = page.icon;
            return (
              <button
                key={page.id}
                className={`nav-link ${currentPage === page.id ? 'active' : ''}`}
                onClick={() => {
                  onPageChange(page.id);
                  setMenuOpen(false);
                }}
              >
                <Icon size={20} />
                <span>{page.label}</span>
              </button>
            );
          })}

          {overflowPages.length > 0 && (
            <div className="nav-more">
              <button className={`nav-link ${moreOpen ? 'active' : ''}`} onClick={() => setMoreOpen(!moreOpen)}>
                <FiMoreHorizontal size={20} />
                <span>Plus</span>
              </button>
              {moreOpen && (
                <div className="more-dropdown">
                  {overflowPages.map(p => {
                    const Icon = p.icon;
                    return (
                      <button key={p.id} className={`nav-link dropdown-item ${currentPage === p.id ? 'active' : ''}`} onClick={() => { onPageChange(p.id); setMoreOpen(false); setMenuOpen(false); }}>
                        <Icon size={16} />
                        <span>{p.label}</span>
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </nav>

        <div className="header-actions">
          {user && <span className="user-name">Bienvenue, {user.name}</span>}
          {user && (
            <button className="btn-logout" onClick={logout} title="Déconnexion">
              <FiLogOut />
            </button>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
